export default (error) => {
  console.error('[Apollo Error]', error, Object.keys(error).reduce((all, key) => ({
    ...all,
    [key]: error[key]
  }), {}))
}
